(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68370],{

/***/ 25670:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/promotion",
      function () {
        return __webpack_require__(13682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53339);
/* harmony import */ var _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33481);
/* harmony import */ var _components_Tip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55390);
/* harmony import */ var _components_CodeSample__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72308);



/* @jsxRuntime classic */ /* @jsx mdx */ 






var Layout = _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__/* .DocumentationLayout */ .L;
var meta = {
    "id": "promotion",
    "title": "Promotion",
    "sidebar_label": "Promotion"
};
var slug = "promotion";
var tableOfContents = [
    {
        "title": "Creating Promotions",
        "slug": "creating-promotions",
        "children": []
    },
    {
        "title": "Promo Banners in Admin",
        "slug": "promo-banners-in-admin",
        "children": []
    },
    {
        "title": "Banner Placement",
        "slug": "banner-placement",
        "children": []
    },
    {
        "title": "Banner Destination",
        "slug": "banner-destination",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__/* .ContentsLayout */ .X_;
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://developer.tradly.app/#afed06fb-a843-43d3-a350-cab722ef9968"
    }), "API REFERENCE"), "| ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://superadmin.tradly.app/promotions"
    }), "Promotion in SuperAdmin")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Promotions are banners and videos placed in strategic locations to attract attention and promote a particular product, service, or message. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "In Tradly, promotions can be directed towards a listing, an account, an external link, or a static message. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/promotion1.png"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "creating-promotions",
        nextElement: {
            "type": "paragraph"
        }
    }, "Creating Promotions"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "To create a promotion, you can use the following options:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Destination: Choose where you want the promotion to link to (e.g. a listing, an account, an external link, or a static message)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Schedules: Choose when you want the promotion to start and end"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Placement type: Choose where you want the promotion to be placed (e.g. on the homepage, in a particular section)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Channel: Choose which channel you want the promotion to run on (e.g. web or app)")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "promo-banners-in-admin",
        nextElement: {
            "type": "paragraph"
        }
    }, "Promo Banners in Admin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As a platform owner, you can use the media section to display promotional materials in prime locations. This could be used to promote important promotions, provide how-to guides, explain features, promote specific products, advertise placements, or direct users to a particular tag (a group of listings)."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "To add banners:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Give the banner a name (we recommend using a naming convention like “month_campaigntype_optionalnote” for easy analysis and tracking in the future)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Upload an image and crop it as needed"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Choose the target destination for the banner"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Set the start and end dates for the banner using the schedules"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Activate or deactivate the banner using the status function")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "banner-placement",
        nextElement: {
            "type": "paragraph"
        }
    }, "Banner Placement"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "You can upload different banners for mobile and web applications with different dimensions and settings. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Mobile banner size: 1280 x 720 (the same size you would use for creating Facebook ads on Canva or other platforms)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "The app will automatically resize the banner to fit the mobile screen, taking up approximately 80% of the space (excluding padding and card UI)")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "banner-destination",
        nextElement: {
            "type": "paragraph"
        }
    }, "Banner Destination"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Banners can be configured for different actions. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Static banners: Use banners as informational or promotional banners"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Listing banners: Use banners to promote a particular listing (we recommend including a call-to-action button to differentiate these banners)")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 72308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports CodeSample, ResizableCodeSample */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62370);






var codeBackground = {
    amber: "bg-amber-500",
    emerald: "bg-emerald-500",
    fuchsia: "bg-fuchsia-400",
    indigo: "bg-indigo-400",
    lightBlue: "bg-light-blue-500",
    purple: "bg-purple-400",
    rose: "bg-rose-400"
};
var previewBackground = {
    amber: "bg-gradient-to-r from-amber-50 to-amber-100",
    emerald: "bg-gradient-to-r from-emerald-50 to-teal-100",
    fuchsia: "bg-gradient-to-r from-fuchsia-50 to-fuchsia-100",
    gray: "bg-gradient-to-r from-gray-50 to-gray-100",
    indigo: "bg-gradient-to-r from-indigo-50 to-indigo-100",
    lightBlue: "bg-gradient-to-r from-light-blue-50 to-light-blue-100",
    purple: "bg-gradient-to-r from-purple-50 to-purple-100",
    rose: "bg-gradient-to-r from-rose-50 to-rose-100"
};
var containerBackground = {
    amber: "bg-stripes bg-stripes-amber-500 bg-amber-100",
    emerald: "bg-stripes bg-stripes-emerald-500 bg-emerald-100",
    fuchsia: "bg-stripes bg-stripes-fuchsia-500 bg-fuchsia-100",
    indigo: "bg-stripes bg-stripes-indigo-500 bg-indigo-100",
    lightBlue: "bg-stripes bg-stripes-light-blue-500 bg-light-blue-100",
    purple: "bg-stripes bg-stripes-purple-500 bg-purple-100",
    rose: "bg-stripes bg-stripes-rose-500 bg-rose-100"
};
var handle = {
    amber: "text-amber-700",
    emerald: "text-emerald-700",
    fuchsia: "text-fuchsia-700",
    indigo: "text-indigo-700",
    lightBlue: "text-light-blue-700",
    purple: "text-purple-700",
    rose: "text-rose-700"
};
function Frame(props) {
    var ref = useRef();
    var ref1 = useState(false), frameLoaded = ref1[0], setFrameLoaded = ref1[1];
    var ref2 = useState({}), style = ref2[0], setStyle = ref2[1];
    useEffect(function() {
        var updateStyle = function updateStyle() {
            setStyle({
                height: ref.current.contentDocument.body.scrollHeight
            });
        };
        if (!frameLoaded) return;
        var observer = new window.ResizeObserver(updateStyle);
        updateStyle();
        observer.observe(ref.current.contentDocument.body);
        return function() {
            observer.disconnect();
        };
    }, [
        frameLoaded
    ]);
    return /*#__PURE__*/ _jsx("iframe", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        onLoad: function() {
            return setFrameLoaded(true);
        },
        style: style
    }));
}
function Snippet(param) {
    var color = param.color, snippet = param.snippet;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("overflow-hidden rounded-b-xl", codeBackground[color], {
            "bg-gray-800": !codeBackground[color]
        }),
        children: /*#__PURE__*/ _jsx("pre", {
            className: clsx("scrollbar-none overflow-x-auto p-6 text-sm leading-snug language-html text-gray-50", {
                "bg-black bg-opacity-75": codeBackground[color]
            }),
            children: /*#__PURE__*/ _jsx("code", {
                className: "language-html",
                dangerouslySetInnerHTML: {
                    __html: snippet
                }
            })
        })
    });
}
function CodeSample(param) {
    var preview = param.preview, src = param.src, snippet = param.snippet, previewClassName = param.previewClassName, _color = param.color, color = _color === void 0 ? "gray" : _color;
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-prose relative overflow-hidden mb-8",
        children: [
            preview ? /*#__PURE__*/ _jsx("div", {
                className: clsx("rounded-t-xl overflow-hidden", previewBackground[color], previewClassName, {
                    "p-10": !previewClassName
                }),
                dangerouslySetInnerHTML: {
                    __html: preview
                }
            }) : /*#__PURE__*/ _jsx(Frame, {
                src: src,
                className: clsx("w-full rounded-t-xl", previewBackground[color])
            }),
            /*#__PURE__*/ _jsx(Snippet, {
                color: color,
                snippet: snippet
            })
        ]
    });
}
function ResizableCodeSample(param) {
    var preview = param.preview, src = param.src, previewClassName = param.previewClassName, snippet = param.snippet, _color = param.color, color = _color === void 0 ? "gray" : _color, _min = param.min, min = _min === void 0 ? false : _min;
    var previewContainerRef = useRef();
    var x = useMotionValue(0);
    var constraintsRef = useRef();
    var ref = useState(false), dragging = ref[0], setDragging = ref[1];
    useEffect(function() {
        var observer = new window.ResizeObserver(function() {
            x.set(0);
        });
        observer.observe(previewContainerRef.current);
        return function() {
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-prose relative mb-8",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                ref: previewContainerRef,
                className: "relative rounded-t-xl ".concat(containerBackground[color]),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: min ? "md:w-88" : undefined,
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            className: "relative",
                            style: {
                                marginRight: useTransform(x, function(x) {
                                    return -x;
                                })
                            },
                            children: preview ? /*#__PURE__*/ _jsx("div", {
                                className: clsx("rounded-t-xl", previewClassName, previewBackground[color], {
                                    "p-10": !previewClassName
                                }),
                                dangerouslySetInnerHTML: {
                                    __html: preview
                                }
                            }) : /*#__PURE__*/ _jsx(Frame, {
                                src: src,
                                className: clsx("w-full rounded-t-xl", previewBackground[color], {
                                    "pointer-events-none": dragging
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: constraintsRef,
                        className: "absolute inset-y-0 -right-4 left-80 ml-4 pointer-events-none",
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            drag: "x",
                            _dragX: x,
                            dragMomentum: false,
                            dragElastic: 0,
                            dragConstraints: constraintsRef,
                            className: "pointer-events-auto absolute top-1/2 -mt-4 w-8 hidden md:flex items-center justify-center cursor-grab active:cursor-grabbing ".concat(min ? "right-0 md:left-0 md:right-auto" : "right-0"),
                            style: {
                                x: x
                            },
                            onDragStart: function() {
                                document.body.classList.add("cursor-grabbing");
                                setDragging(true);
                            },
                            onDragEnd: function() {
                                document.body.classList.remove("cursor-grabbing");
                                setDragging(false);
                            },
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "flex-none rounded bg-white shadow flex items-center justify-center h-8",
                                style: {
                                    width: "0.9375rem"
                                },
                                children: /*#__PURE__*/ _jsx("svg", {
                                    viewBox: "0 0 14 24",
                                    fill: "none",
                                    strokeWidth: "2",
                                    stroke: "currentColor",
                                    className: "h-3 flex-none ".concat(handle[color]),
                                    style: {
                                        width: "0.4375rem"
                                    },
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M 1 0 V 24 M 7 0 V 24 M 13 0 V 24"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Snippet, {
                color: color,
                snippet: snippet
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [43430,73320,85220,96401,91586,48777,26852,5679,63432,49774,92888,40179], function() { return __webpack_exec__(25670); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);